<template>
    <div class="top">
        <div class="header-act">
            <div class="logo-wrap" @click="$router.push('/')">
                <img src="https://file.zmxs.com.cn/img/newLogo2026-09-02140102.png" alt="" class="logo-img " />
            </div>
            <div class="nav-menu">
                <template v-for="(m, i) in menuArr">
                    <router-link v-if="m.type === 'link'" :key="'nav-link-' + (m.to || i)"
                        :class="{ page: true, actcolor: isMenuActive(m) }" :to="m.to">{{ m.label }}</router-link>
                    <div v-else-if="m.type === 'dropdown'" :key="'nav-drop-' + (m.label || i)" class="nav-dropdown"
                        @mouseenter="handleDropdownEnter(m.label)" @mouseleave="handleDropdownLeave">
                        <div class="el-dropdown-link" :class="{ 'is-open': openDropdownKey === m.label }">
                            <span>{{ m.label }}</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                        <div class="dropdown-panel" :class="{ 'is-open': openDropdownKey === m.label }">
                            <div v-for="(child, j) in m.children" :key="'drop-item-' + (child.command || j)"
                                class="dropdown-item" :class="{ 'is-active': isDropdownChildActive(child) }"
                                @click="handleDropCommand(child.command)">
                                <div class="dropdown-item__value">{{ child.value }}</div>
                                <div class="dropdown-item__label">{{ child.label }}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="right-wrap">
                <div class="theme-btn" @click="toggleTheme">
                    <i v-if="isDark" class="el-icon-moon"></i>
                    <i v-else class="el-icon-sunny"></i>
                    <span class="divider">·</span>
                    <span class="theme-text">{{ isDark ? '暗 · 悬赏招聘' : '亮 · AI 面试' }}</span>
                </div>
                <div @click="handBtn" class="try-btn">企业端登录</div>
            </div>
        </div>
    </div>
</template>

<script>
import { removeUser } from "@/plugins/auth.js";
import { eventLog } from "@/utils/index.js";
import { menuArr } from "@/router/config.js";

export default {
    data() {
        const currentRoute = this.$route || { params: {}, name: '' };
        return {
            routeParams: currentRoute.params || {},
            user: "",
            isDark: false,
            openDropdownKey: null,
            menuArr,
            routerList: {
                'index': 'page_home_view',
                'bountyRecruitment': 'page_bounty_recruitment_view',
                'employment': 'page_employment_view',
                'talent-management': 'page_talent_management_view',
                'interview': 'page_interview_view',
                'example': 'page_example_view',
                'news': 'page_news_view',
                'about-us': 'page_about_us_view',
            }
        };
    },
    created() {
        this.mql = window.matchMedia('(prefers-color-scheme: dark)');
        this.isDark = this.mql.matches;
        this.applyTheme(this.isDark);

        this.onSystemThemeChange = (e) => {
            this.isDark = e.matches;
            this.applyTheme(this.isDark);
            window.dispatchEvent(new CustomEvent('theme-updated', { detail: this.isDark }));
            this.$root.$emit('theme-updated', this.isDark);
        };
        this.mql.addEventListener('change', this.onSystemThemeChange);

        this.onThemeUpdate = (e) => {
            this.isDark = e.detail;
            this.applyTheme(this.isDark);
        };
        window.addEventListener('theme-updated', this.onThemeUpdate);
        eventLog(this.routerList[(this.$route && this.$route.name) || ''])
    },
    beforeDestroy() {
        window.removeEventListener('theme-updated', this.onThemeUpdate);
        if (this.mql) {
            this.mql.removeEventListener('change', this.onSystemThemeChange);
        }
    },
    watch: {
        $route: {
            handler: function (val) {
                Object.assign(this.routeParams, (val && val.params) || {});
            },
            deep: true,
        },
    },
    methods: {
        applyTheme(isDark) {
            const root = document.documentElement;
            if (isDark) {
                root.style.setProperty('--header-bg', '#120E30');
                root.style.setProperty('--nav-text', '#EFF1FB');
                root.style.setProperty('--nav-active', '#ffffff');
                root.style.setProperty('--dropdown-bg', '#1c1742');
                root.style.setProperty('--dropdown-hover', '#2b245c');
                root.style.setProperty('--body-bg', '#120E30');
                root.style.setProperty('--top-bg', '#0A0C1E');
                root.style.setProperty('--nav1-text', '#EFF1FB');
                root.style.setProperty('--two-bg', '#0A0C1E');
                root.style.setProperty('--card-shadow', 'none');
                root.style.setProperty('--card-border', 'none');
                root.style.setProperty('--item-border', 'none');
            } else {
                root.style.setProperty('--header-bg', '#ffffff');
                root.style.setProperty('--nav-text', '#222');
                root.style.setProperty('--nav-active', '#953de8');
                root.style.setProperty('--dropdown-bg', '#ffffff');
                root.style.setProperty('--dropdown-hover', '#f0f0f0');
                root.style.setProperty('--body-bg', '#f7f8fc');
                root.style.setProperty('--top-bg', '#fff');
                root.style.setProperty('--two-bg', '#FBF8FF');
                root.style.setProperty('--nav1-text', 'rgba(102, 102, 102, 0.72)');
                root.style.setProperty('--card-shadow', '0px 26px 52px 0px #D2C9EB');
                root.style.setProperty('--card-border', '1px solid #D8CBFF');
                root.style.setProperty('--item-border', '0px 18px 48px 0px #E5DEF9');
            }
        },
        handBtn() {
            eventLog('click_free_try')
            window.open('https://job.zmxs.com.cn')
        },
        edit() {
            removeUser();
            this.$router.push("/login");
        },
        handleDropCommand(path) {
            this.openDropdownKey = null;
            this.$router.push(path);
        },
        handleDropdownEnter(label) {
            this.openDropdownKey = label;
        },
        handleDropdownLeave() {
            this.openDropdownKey = null;
        },
        isDropdownChildActive(child) {
            const currentPath = ((this.$route && this.$route.path) || '').replace(/\/+$/, '') || '/';
            const childPath = (child && child.command ? child.command : '').replace(/\/+$/, '') || '/';
            return currentPath === childPath;
        },
        isMenuActive(menu) {
            if (!menu || !menu.activeNames || !menu.activeNames.length) return false;
            return menu.activeNames.indexOf((this.$route && this.$route.name) || '') > -1;
        },
        toggleTheme() {
            this.isDark = !this.isDark;
            this.applyTheme(this.isDark);
            window.dispatchEvent(new CustomEvent('theme-updated', { detail: this.isDark }));
            this.$root.$emit('theme-updated', this.isDark)
        }
    },
    computed: {
        info() {
            return this.$store.state.userstore.userInfo;
        },
    },
};
</script>

<style lang="less" scoped>
.top {
    width: 100%;
    height: 72px;
    background-color: #07081A;
    border-bottom: 1px solid rgba(184, 108, 255, 0.15);
    transition: background 0.35s;

    .header-act {
        height: 72px;
        max-width: 1280px;
        width: 92%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo-wrap {
            cursor: pointer;

            .logo-img {
                width: 128px;
                height: 33px;
            }
        }

        .nav-menu {
            display: flex;
            align-items: center;
            gap: 8px;

            .page {
                padding: 0 16px;
                color: #A59CC2;
                font-size: 16px;
                text-decoration: none;
                transition: color 0.3s;
            }

            .actcolor {
                color: #A59CC2 !important;
                font-weight: 600;
            }

            .page:hover {
                color: #fff;
            }

            .el-dropdown-link {
                position: relative;
                padding: 0 16px;
                color: #A59CC2;
                font-size: 16px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 4px;
                transition: color 0.3s;

                &:hover {
                    color: var(--nav-active);
                }

                &.is-open {
                    color: #ffffff;
                }

                i {
                    font-size: 14px;
                    transition: transform 0.25s ease;
                }

                &.is-open i {
                    transform: rotate(180deg);
                }
            }

            .nav-dropdown {
                position: relative;
                padding: 22px 0;
                margin: -22px 0;
            }

            .dropdown-panel {
                position: absolute;
                top: 100%;
                left: 50%;
                width: 244px;
                padding: 18px 18px 16px;
                border: 1px solid #20223E;
                border-radius: 16px;
                background: #07081A;
                box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.3);
                transform: translateX(-50%) translateY(10px);
                opacity: 0;
                visibility: hidden;
                pointer-events: none;
                transition: opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease;
                z-index: 30;

                &.is-open {
                    opacity: 1;
                    visibility: visible;
                    pointer-events: auto;
                    transform: translateX(-50%) translateY(0);
                }

                &::before {
                    content: '';
                    position: absolute;
                    top: -9px;
                    left: 50%;
                    width: 18px;
                    height: 18px;
                    border-top: 1px solid rgba(73, 83, 160, 0.34);
                    border-left: 1px solid rgba(73, 83, 160, 0.34);
                    background: rgba(9, 11, 41, 0.98);
                    transform: translateX(-50%) rotate(45deg);
                }
            }

            .dropdown-item {
                position: relative;
                padding: 15px 18px 16px;
                border-radius: 18px;
                cursor: pointer;
                transition: background-color 0.25s ease, box-shadow 0.25s ease;
                border-bottom: 1px solid #20223E;

                &:not(:last-child) {
                    margin-bottom: 8px;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: -4px;
                        height: 1px;
                        background: rgba(122, 132, 214, 0.16);
                    }
                }

                &:hover,
                &.is-active {
                    background: #20223E;
                    color: #fff;
                    box-shadow: inset 0 0 0 1px rgba(113, 121, 210, 0.08);

                    .dropdown-item__value,
                    .dropdown-item__label {
                        color: #fff;
                    }
                }
            }

            .dropdown-item__value {
                font-size: 16px;
                font-weight: 700;
                line-height: 22px;
                color: #A59CC2;
            }

            .dropdown-item__label {
                font-size: 16px;
                line-height: 16px;
                color: #756E8C;
            }
        }

        .right-wrap {
            display: flex;
            align-items: center;
            gap: 20px;

            // 胶囊按钮 1:1复刻
            .theme-btn {
                height: 40px;
                padding: 0 24px;
                border-radius: 999px;
                border: 1px solid rgba(200, 170, 255, 0.35);
                background: transparent;
                display: flex;
                align-items: center;
                gap: 10px;
                font-size: 16px;
                color: #A59CC2;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    border-color: rgba(233, 230, 238, 0.8);
                    color: #fff;
                }

                .divider {
                    font-size: 18px;
                    line-height: 1;
                }
            }

            .try-btn {
                height: 36px;
                padding: 8px 19px;
                border-radius: 22px;
                background: #7C50FF;
                color: #ffffff;
                font-size: 16px;
                display: flex;
                align-items: center;
                cursor: pointer;
                white-space: nowrap;
                transition: opacity 0.25s;

                &:hover {
                    opacity: 0.88;
                }
            }
        }
    }
}
</style>
